import type { HermesGuardFn } from '@/router/guards/types'
import { useFeatureFlags } from '@/utils/useFeatureFlags'

export const checkMarketingOverviewV2FeatureFlag: HermesGuardFn = async (
  to
) => {
  const featureFlags = useFeatureFlags()
  const flagEnabled = featureFlags.isEnabled('hermes.marketingOverviewV2')

  if (to.name === 'brand.tools.marketing-overview' && !flagEnabled) {
    return {
      name: 'brand.marketing.overview',
      params: { brandId: to.params.brandId },
    }
  }

  return undefined
}
